<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="mb-4">Relatórios Agrupados</h2>

          <b-table :items="reports" :fields="fields" responsive="sm">
            <template v-slot:cell(actions)="data">
              <b-button size="sm" @click="showReport(data.item.token)">Acessar</b-button>

              <b-button size="sm" @click="editReport(data.item.token, data.item.name, data.item.event_ids, data.item.user_ids)" class="ml-2">Editar</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AdminGroupedReportList',
  data() {
    return {
      reports: [],
      fields: [
        { key: 'name', label: 'Nome do Relatório' },
        { key: 'total_events', label: 'Total de Operações', class: ['text-center', 'align-middle'] },
        { key: 'total_users', label: 'Total de Usuários', class: ['text-center', 'align-middle'] },
        { key: 'created_at', label: 'Criado em', formatter: this.$options.filters.date, class: ['text-center', 'align-middle'] },
        { key: 'actions', label: 'Ações' }
      ]
    }
  },
  mounted () {
    if (this.$route.params.scrollTo === 'top') {
      this.scrollToTop()
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showReport(token) {
      this.$router.push({ name: 'AdminShowGroupedReport', params: { token: token } });
    },
    editReport(token, name, eventIds, userIds) {
      this.$router.push({ name: 'AdminEditGroupedReport', params: { token: token, name: name, eventIds: eventIds, userIds: userIds } });
    },
    async fetchReports() {
      try {
        const response = await this.$http.get(`${process.env.VUE_APP_URL_APP}/b/admin/grouped-reports`);
        this.reports = response.body.reports;
      } catch (err) {
        console.error(err);
      }
    }
  },
  async created() {
    await this.fetchReports();
  }
}
</script>
